<template>
<main class="container-1 assign-view">

    <div class="container-header">
        <MapDetailHeader :map="map" />
        <p class="assign-view__hint">Los cambios se guardan al instante.</p>
    </div>

    <div class="assign-filters">
        <input id="search" v-model="inputGroup" type="text" placeholder="Buscar grupo..." />
    </div>

    <div class="assign-panels">

        <!-- Panel: grupos disponibles -->
        <section class="apanel">
            <header class="apanel__head">
                <strong>Disponibles</strong>
                <span class="apanel__count">{{ availableGroups.length }}</span>
            </header>

            <div class="apanel__body">
                <div
                v-for="item in availableGroups"
                v-bind:key="item.id"
                class="arow">
                    <input type="checkbox" class="arow__check" :checked="isSelected(selAvailable, item.id)" v-on:change="toggleSelection(selAvailable, item.id)" :aria-label="'Seleccionar ' + item.name" />
                    <span class="arow__info">
                        <b class="arow__name">{{ item.name }}</b>
                        <small class="arow__desc">{{ item.desc }}</small>
                    </span>
                    <button class="btn btn-primary btn-row" v-on:click="assignGroup(item)">+ Asignar</button>
                </div>

                <p v-if="!availableGroups.length" class="apanel__empty">No hay grupos disponibles.</p>
            </div>

            <footer class="apanel__foot apanel__foot--between">
                <label class="apanel__selall">
                    <input type="checkbox" :checked="allSelected(availableGroups, selAvailable)" v-on:change="toggleSelectAll(selAvailable, availableGroups)" />
                    Seleccionar todos
                </label>
                <button class="btn btn-primary btn-row" :disabled="!selectedItems(availableGroups, selAvailable).length" v-on:click="assignSelected()">Asignar seleccionados ({{ selectedItems(availableGroups, selAvailable).length }})</button>
            </footer>
        </section>

        <!-- Panel: grupos asignados -->
        <section class="apanel">
            <header class="apanel__head">
                <strong>Asignados al mapa</strong>
                <span class="apanel__count apanel__count--on">{{ assignedInView.length }}</span>
            </header>

            <div class="apanel__body">
                <div
                v-for="item in assignedInView"
                v-bind:key="item.id"
                class="arow">
                    <input type="checkbox" class="arow__check" :checked="isSelected(selAssigned, item.id)" v-on:change="toggleSelection(selAssigned, item.id)" :aria-label="'Seleccionar ' + item.name" />
                    <span class="arow__info">
                        <b class="arow__name">{{ item.name }}</b>
                        <small class="arow__desc">{{ item.desc }}</small>
                    </span>
                    <button class="btn btn-danger btn-row" v-on:click="unassignGroup(item)">Quitar</button>
                </div>

                <p v-if="!assignedInView.length" class="apanel__empty">Aún no hay grupos asignados.</p>
            </div>

            <footer class="apanel__foot apanel__foot--between">
                <label class="apanel__selall">
                    <input type="checkbox" :checked="allSelected(assignedInView, selAssigned)" v-on:change="toggleSelectAll(selAssigned, assignedInView)" />
                    Seleccionar todos
                </label>
                <button class="btn btn-danger btn-row" :disabled="!selectedItems(assignedInView, selAssigned).length" v-on:click="unassignSelected()">Quitar seleccionados ({{ selectedItems(assignedInView, selAssigned).length }})</button>
            </footer>
        </section>

    </div>

</main>
</template>

<script>
// @ is an alias to /src
import MapDetailHeader from '@/components/MapDetailHeader.vue'
import {assignSelection} from '@/components/mixin/assignSelection.js'

export default{
    name: 'MapsAssignGroups',
    mixins: [assignSelection],
    data(){
        return{
            map: '',

            allGroups: [],
            assignedGroups: [],

            inputGroup: '',
            message: '',
        }
    },
    components:{
        MapDetailHeader
    },
    computed: {
        // Grupos que coinciden con la búsqueda (nombre o descripción)
        matchedGroups: function() {
            var list = this.allGroups || [];
            var text = this.inputGroup.trim().toLowerCase();
            if (!text) {
                return list;
            }
            return list.filter(function(group){
                var name = (group.name || '').toLowerCase();
                var desc = (group.desc || '').toLowerCase();
                return name.indexOf(text) !== -1 || desc.indexOf(text) !== -1;
            });
        },
        // La pertenencia se deriva de assignedGroups en vez de marcar una bandera sobre cada
        // elemento de allGroups: agregar una propiedad nueva a un objeto no es reactivo en
        // Vue 2 y obliga a depender del orden de las respuestas.
        assignedIds: function() {
            return (this.assignedGroups || []).map(function(group){ return group.id; });
        },
        availableGroups: function() {
            var ids = this.assignedIds;
            return this.matchedGroups.filter(function(group){ return ids.indexOf(group.id) === -1; });
        },
        assignedInView: function() {
            var ids = this.assignedIds;
            return this.matchedGroups.filter(function(group){ return ids.indexOf(group.id) !== -1; });
        }
    },
    props: [],
    methods:{
        getMap: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap)
            .then(function (response) {
                that.map = response.data;
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAllGroups: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/groups/') //Sin paginación
            .then(function (response) {
                that.allGroups = response.data;
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedGroups: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/groups') //Sin paginación
            .then(function (response) {
                that.assignedGroups = response.data;
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        assignGroup: function(group){
            var that = this;
            this.$http.post(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/groups/' + group.id,
            {
                id_map: this.$route.params.idMap,
                id_group: group.id
            })
            .then(function (response) {
                that.getAssignedGroups();
            })
            .catch(function (error) {
                console.log(error);
                that.message = error.response.data.message;
            });
        },
        unassignGroup: function(group){
            var that = this;
            this.$http.delete(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/groups/' + group.id)
            .then(function (response) {
                that.getAssignedGroups();
            })
            .catch(function (error) {
                console.log(error);
                that.message = error.response.data.message;
            });
        },
        assignSelected: function(){
            var that = this;
            this.selectedItems(this.availableGroups, this.selAvailable).forEach(function(group){
                that.assignGroup(group);
            });
            this.selAvailable.splice(0);
        },
        unassignSelected: function(){
            var that = this;
            this.selectedItems(this.assignedInView, this.selAssigned).forEach(function(group){
                that.unassignGroup(group);
            });
            this.selAssigned.splice(0);
        }
    },
    created () {
        this.$store.getters.getPermissions.maps? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getMap();
        this.getAllGroups();
        this.getAssignedGroups();
    }
}
</script>

<style lang="scss" scoped>
.assign-view__hint {
    margin: 0.15rem 0 0;
    font-size: 0.78rem;
    color: var(--color-ghost);
}

.assign-filters {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin: 0.7rem 0 0.85rem;
}

.assign-filters input {
    width: 100%;
    padding: 0.5em 0.7em;

    border: 1px solid var(--color-line);
    border-radius: 7px;
    background: var(--color-white);
    color: var(--color-graphite);

    font-family: inherit;
    font-size: 0.9rem;
}

.assign-filters input:focus {
    outline: none;
    border-color: var(--color-steel);
    box-shadow: 0 0 0 3px rgba(59, 110, 148, 0.15);
}

.assign-panels {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.9rem;
    align-items: start;
}

.apanel {
    display: flex;
    flex-direction: column;

    background: var(--color-white);
    border: 1px solid var(--color-line);
    border-radius: 10px;
    overflow: hidden;
}

.apanel__head {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    padding: 0.6rem 0.8rem;
    background: var(--color-mist);
    border-bottom: 1px solid var(--color-line);
}

.apanel__head strong {
    font-size: 0.9rem;
    color: var(--color-navy);
}

.apanel__count {
    margin-left: auto;
    min-width: 1.7em;
    padding: 0.05rem 0.5rem;

    border-radius: 999px;
    background: var(--color-steel);
    color: #fff;

    font-size: 0.72rem;
    font-weight: 700;
    text-align: center;
}

.apanel__count--on {
    background: var(--color-success);
}

.apanel__body {
    max-height: 52vh;
    overflow-y: auto;
}

.arow {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.5rem 0.7rem;
    transition: background-color 0.12s ease;
}

.arow + .arow {
    border-top: 1px solid var(--color-line);
}

.arow:hover {
    background: var(--color-mist);
}

.arow__info {
    flex: 1;
    min-width: 0;
}

.arow__name {
    display: block;
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--color-navy);
    word-break: break-word;
}

.arow__desc {
    font-size: 0.72rem;
    color: var(--color-ghost);
    word-break: break-word;
}

.apanel__foot {
    display: flex;
    justify-content: flex-end;

    margin-top: auto;
    padding: 0.6rem 0.7rem;
    border-top: 1px solid var(--color-line);
}

.apanel__empty {
    margin: 0;
    padding: 2rem 1rem;
    text-align: center;
    color: var(--color-ghost);
    font-style: italic;
}

.btn-row {
    padding: 0.32em 0.8em;
    font-size: 0.8rem;
}

.arow__check {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    accent-color: var(--color-steel);
    cursor: pointer;
}

.apanel__foot--between {
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.apanel__selall {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.76rem;
    color: var(--color-graphite);
    cursor: pointer;
    white-space: nowrap;
}

.apanel__selall input {
    accent-color: var(--color-steel);
    cursor: pointer;
}

@media only screen and (max-width: 760px) {
    .assign-panels {
        grid-template-columns: 1fr;
    }
}
</style>
